import { IOrder } from "./models/Order";
import { IProduct } from "./models/Product";

interface IBackendConnector {
	sendOrder(order: IOrder): Promise<Response>;
}

class DefaultBackendConnector implements IBackendConnector {
	public sendOrder(order: IOrder): Promise<Response> {
		// TODO: Display error to user if incompatible browser. Maybe write a global function or add a window.onError handler if possible
		const url = `${this.getBaseURL()}/api/order`;
		return this.postJSON(url, order);
	}

	public getProducts(): Promise<IProduct[]> {
		// TODO: Use once backend holds products
		// return fetch("/api/product").then(res => {
		// 	if (res.status === 200) {
		// 		return res.json();
		// 	} else {
		// 		throw new Error("Unexpected status " + res.status);
		// 	}
		// })
		return Promise.reject("Not implemented!");
	}

	private postJSON(url: string, data: object): Promise<Response> {
		return fetch(url, {
			body: JSON.stringify(data),
			headers: {
				"Content-Type": "application/json"
			},
			method: "POST",
			redirect: "follow",
			referrer: "no-referrer"
		}) 
	}

	private getBaseURL(): string {
		return window.location.origin;
	}
}

export const DEFAULT_BACKEND_CONNECTOR: IBackendConnector = new DefaultBackendConnector();



// WEBPACK FOOTER //
// ./src/api/BackendConnector.ts